{
  "aiGeneratedAnswer": "Răspuns generat de AI",
  "allCategories": "Toate categoriile",
  "appliedFiltersToCurrentSearch": "Filtre aplicate la căutarea curentă",
  "apply": "Aplică",
  "applyFilters": "Aplică filtre",
  "autocompleteOptionsFound_few": "{{count}}{{label}} opțiuni de completare automată găsite.",
  "autocompleteOptionsFound_one": "{{count}}{{label}} opțiune de completare automată găsită.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} opțiuni de completare automată găsite.",
  "autocompleteSuggestion": "sugestie completă automată: {{suggestion}}",
  "autocompleteSuggestionsFound_few": "{{count}} sugestii de completare automată găsite.",
  "autocompleteSuggestionsFound_one": "{{count}} sugestie de completare automată găsită.",
  "autocompleteSuggestionsFound_other": "{{count}} sugestii de completare automată găsite.",
  "basedOnYourDevice": " (bazat pe dispozitivul tău)",
  "basedOnYourInternetAddress": " (bazat pe adresa ta de internet)",
  "categoriesText_few": "Următoarele categorii au generat rezultate pentru – <strong>{{query}}</strong>",
  "categoriesText_one": "Următoarea categorie a generat rezultate pentru – <strong>{{query}}</strong>",
  "categoriesText_other": "Următoarele categorii au generat rezultate pentru – <strong>{{query}}</strong>",
  "clearAll": "Ștergeți toate",
  "clearMinAndMax": "Șterge min și max",
  "clearTheRangeToSelectOptions": "Ștergeți intervalul pentru a selecta opțiuni.",
  "clearTheSearchBar": "Ștergeți bara de căutare",
  "conductASearch": "Efectuați o căutare",
  "currentLocation": "Locația curentă",
  "didYouMean": "Ai vrut să spui <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Când sunt disponibile rezultate de completare automată, folosește săgețile sus și jos pentru a naviga și Enter pentru a selecta.",
  "feedback": "Feedback",
  "invalidRange": "Interval nevalid",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Navigați la pagina de rezultate următoare",
  "navigateToThePreviousResultsPage": "Navigați la pagina de rezultate anterioare",
  "noAutocompleteOptionsFound": "Nu a fost găsită nicio opțiune de completare automată.",
  "noAutocompleteSuggestionsFound": "Nu a fost găsită nicio sugestie de completare automată.",
  "noResultsFoundIn": "Niciun rezultat găsit în {{currentVerticalLabel}}.",
  "pagination": "Paginare",
  "readMoreAbout": "Citește mai mult despre <a>{{name}}</a>",
  "recentSearch": "căutare recentă: {{query}}",
  "recentSearchesFound_few": "{{count}} căutări recente găsite.",
  "recentSearchesFound_one": "{{count}} căutare recentă găsită.",
  "recentSearchesFound_other": "{{count}} căutări recente găsite.",
  "removeFilter": "Elimină filtrul „{{displayName}}“",
  "resultPreview": "rezultat previzualizare: {{value}}",
  "resultPreviewsFound_few": "{{count}} previzualizări ale rezultatelor găsite.",
  "resultPreviewsFound_one": "{{count}} previzualizare a rezultatului găsită.",
  "resultPreviewsFound_other": "{{count}} previzualizări ale rezultatelor găsite.",
  "resultsCountText_few": "{{count}} rezultate",
  "resultsCountText_one": "{{count}} rezultat",
  "resultsCountText_other": "{{count}} de rezultate",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} din {{resultsCount}} rezultate",
  "searchHere": "Căutați aici…",
  "showLess": "Arată mai puțin",
  "showMore": "Arată mai mult",
  "showingAllInstead": "Se afișează toate {{currentVerticalLabel}} în schimb.",
  "sources_few": "Surse ({{count}})",
  "sources_one": "Sursă",
  "sources_other": "Surse ({{count}})",
  "submitSearch": "Trimiteți căutarea",
  "suggestionResultsCount_few": "{{label}} – {{count}} rezultate",
  "suggestionResultsCount_one": "{{label}} – {{count}} rezultat",
  "suggestionResultsCount_other": "{{label}} – {{count}} rezultate",
  "thankYouForYourFeedback": "Mulțumim pentru feedback!",
  "thisAnsweredMyQuestion": "Aceasta a răspuns la întrebarea mea",
  "thisDidNotAnswerMyQuestion": "Aceasta nu a răspuns la întrebarea mea",
  "unselectAnOptionToEnterInARange": "Deselectează o opțiune pentru a introduce un interval.",
  "updateYourLocation": "Actualizați -vă locația",
  "useCurrentLocation": "Folosește locația curentă",
  "useMyLocation": "Folosește locația mea",
  "viewAll": "Vizualizați toate",
  "viewDetails": "Vizualizați detalii"
}
